import { fetchListSections } from '~modules/section/api';
import { SectionDto } from '~modules/section/model';
import { UserDto } from '~modules/user/model';
import { getName } from '~shared/helpers';
import { CheckBox, InputSuggest } from '~shared/ui';

type UsersItemProps = {
	user: UserDto;
	selected: boolean;
	onChange: (id: number, section: SectionDto) => void;
	onSelect: (id: number) => void;
};

export function UsersItem({ user, selected, onChange, onSelect }: UsersItemProps) {
	const handleChangeSection = (val: SectionDto) => {
		onChange(user.id!, val);
	};

	const handleSelect = () => {
		onSelect(user.id!);
	};

	return (
		<tr>
			<td>
				<CheckBox checked={selected} onChange={handleSelect} />
			</td>
			<td>{getName(user)}</td>
			<td>{user.position}</td>
			<td>
				<InputSuggest
					placeholder="Участок"
					value={user.section}
					onSearch={fetchListSections}
					onChange={handleChangeSection}
					stringify={val => (val ? val.title : null)}
				/>
			</td>
		</tr>
	);
}
